import { NgModule } from '@angular/core';

import * as ApiServiceProxies from './service-proxies';

@NgModule({
    providers: [
        ApiServiceProxies.AuthServiceProxy,
        ApiServiceProxies.LanguageServiceProxy,
        ApiServiceProxies.PermissionServiceProxy,
        ApiServiceProxies.RegisterServiceProxy,
        ApiServiceProxies.RoleServiceProxy,
        ApiServiceProxies.TenantServiceProxy,
        ApiServiceProxies.UserServiceProxy,
        ApiServiceProxies.OrgUnitServiceProxy,
        ApiServiceProxies.UserConfigurationServiceProxy,
        ApiServiceProxies.ChangeLogServiceProxy,
        ApiServiceProxies.MailGroupServiceProxy,
        ApiServiceProxies.FileServiceProxy,
        ApiServiceProxies.HostSettingsServiceProxy,
        ApiServiceProxies.TenantSettingsServiceProxy,
        ApiServiceProxies.AuditLogServiceProxy,
        ApiServiceProxies.WebLogServiceProxy,
        ApiServiceProxies.FriendshipServiceProxy,
        ApiServiceProxies.ChatMessageServiceProxy,
        ApiServiceProxies.HelpServiceProxy,
        ApiServiceProxies.SettingClientServiceProxy,
        ApiServiceProxies.ChatRoomServiceProxy,
        ApiServiceProxies.DynamicCatalogServiceProxy,
        ApiServiceProxies.HospitalesServiceProxy,
        ApiServiceProxies.CatalogosGeneralesServiceProxy,
        ApiServiceProxies.ControlEstatusPacienteServiceProxy,
        ApiServiceProxies.PatientsServiceProxy,
        ApiServiceProxies.ConfigurarHospitalServiceProxy,
        ApiServiceProxies.MedicoUnidadServiceProxy,
        ApiServiceProxies.MedicosServiceProxy,
        ApiServiceProxies.IntegracionIMSSServiceProxy,
        ApiServiceProxies.AccesoVascularPacienteServiceProxy,
        ApiServiceProxies.TurnoHospitalServiceProxy,
        ApiServiceProxies.PrescripcionHDServiceProxy,
        ApiServiceProxies.ControlEstatusMaquinaServiceProxy,
        ApiServiceProxies.CitasServiceProxy,
        ApiServiceProxies.SesionHDServiceProxy,
        ApiServiceProxies.ReportServiceProxy,
        ApiServiceProxies.SessionServiceProxy,
        ApiServiceProxies.MensajesHL7ServiceProxy,
        ApiServiceProxies.EstudiosPacientesServiceProxy,
        ApiServiceProxies.MonitorMaquinasBellcoServiceProxy,
        ApiServiceProxies.ParametrosServiceProxy,
        ApiServiceProxies.EvolucionMedicaServiceProxy
    ]
})
export class ServiceProxyModule { }
